module.exports = __webpack_public_path__ + "static/media/landmark.7b34319e.svg";